module.exports = __webpack_public_path__ + "static/media/clockNotifGrey.e7433f06.svg";